<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ employeeFeature.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employeeFeature.employee_code }}
              {{ employeeFeature.organization }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <v-text-field
          :value="employeeFeature.name"
          readonly
          disabled
          class="fix-google-chrome"
          label="ชื่อ - นามสกุล"
        ></v-text-field>
        <v-text-field
          :value="employeeFeature.employee_code"
          readonly
          disabled
          class="fix-google-chrome"
          label="รหัสพนักงาน"
        ></v-text-field>
        <v-text-field
          :value="employeeFeature.organization"
          readonly
          disabled
          class="fix-google-chrome"
          label="หน่วยงาน"
        ></v-text-field>
        <p>กรุณาเลือกฟีเจอร์ที่ต้องการใช้งาน</p>
        <div
          v-for="feature in employeeFeature.features"
          :key="feature.company_feature_toggle_uuid"
        >
          <v-checkbox
            :disabled="
              feature.employee_count >= feature.limit_max_employee &&
              feature.limit_max_employee !== 0 &&
              !feature.isFeature
            "
            v-model="feature.isFeature"
            hide-details
            dense
            @change="
              feature.isFeature
                ? feature.employee_count++
                : feature.employee_count--
            "
          >
            <template v-slot:label>
              <span class="black--text">{{ feature.feature.title_th }}</span>
            </template>
          </v-checkbox>
          <p class="ml-8 mb-2 grey--text">
            (ฟรี
            {{
              feature.employee_count > feature.limit_free_employee
                ? feature.limit_free_employee
                : feature.employee_count
            }}/{{ feature.limit_free_employee }}, จำกัด
            {{ feature.employee_count }}/{{
              feature.limit_max_employee === 0
                ? 'ไม่จำกัด'
                : feature.limit_max_employee
            }})
          </p>
        </div>
        <div class="d-sr-only">{{ isEmployeeFeatureDataChange }}</div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn tabindex="2" class="primary mr-3" depressed @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: Boolean,
    employeeFeature: Object,
    employeeFeatureInit: Object,
  },
  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isEmployeeFeatureDataChange() {
      if (
        JSON.stringify(this.employeeFeature.features) !==
        JSON.stringify(this.employeeFeatureInit.features)
      ) {
        this.$emit('isEmployeeFeatureDataChange', true)
        return true
      }
      this.$emit('isEmployeeFeatureDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      editEmployeeFeatureToggle: 'feature/editEmployeeFeatureToggle',
    }),
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_uuid: this.employeeFeature.employee_uuid,
          company_feature_toggle: this.employeeFeature.features
            .filter((el) => el.isFeature)
            .map((element) => element.company_feature_toggle_uuid),
        }

        this.editEmployeeFeatureToggle(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isEmployeeFeatureDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      this.$emit('onReset', this.formAction)
      this.$refs.form.reset()
    },
  },
}
</script>
